<div class="container-summary">
  <div class="summary-items" [class.closed]="showAllInfo">
    <div class="summary-subtitle">Abonnement sélectionné</div>
    <div class="summary-line">
      <div class="item-name">{{ subscription?.name }}*</div>
      <div class="item-price">{{ subscription?.basePrice | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}
        <span class="text-xs text-gray-500 font-light">/mois</span></div>
    </div>
    <div class="description">{{ subscription?.description }}</div>
    <div class="text-secondary text-xs mt-4">* Une période d'essai de 30 jours est appliquée. le prélèvement mensuel de l'abonnement
      commencera à la fin de cette période.
    </div>
    <div *ngIf="coupon" class="text-success mt-2">
      Vous bénéficiez d'un tarif personnalisé de {{getSubscriptionDiscountedPrice() | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}
      par mois pendant {{ coupon.duration }} mois. Au terme de cette période, le prix initial de l’abonnement sera rétabli.
    </div>
    <div class="separator"></div>
    <div class="summary-subtitle">Frais annexes</div>
    <div class="summary-line" *ngFor="let addon of subscription?.addons">
      <div class="item-name">{{ addon?.name }}</div>
      <div class="price-line">
        <div [ngClass]="hasCouponForAddon(addon) ? 'item-expired' : 'item-price'">
          {{ addon?.basePrice | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}
        </div>
        <div class="item-price" *ngIf="hasCouponForAddon(addon)">
          {{ getAddonDiscountedPrice(addon) | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}
        </div>
      </div>
     </div>
  </div>
  <div class="separator" [hidden]="showAllInfo"></div>
  <div class="summary-line">
    <div class="item-name">Prix HT</div>
    <div class="item-price">{{ getTotalAmountWithoutTaxes() | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}</div>
  </div>
  <div class="summary-line">
    <div class="item-name">TVA</div>
    <div class="item-price">{{ getTotalTaxes() | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}</div>
  </div>
  <div class="summary-line">
    <div class="text-lg text-secondary">Total TTC</div>
    <div
      class="text-lg font-semibold text-secondary">{{ getTotalWithTaxes() | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}
    </div>
  </div>
</div>
